import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { QuickLinks } from '../components/QuickLinks';
import { PortfolioGrid } from '../components/PortfolioGrid';
import { SectionHeading } from '../components/SectionHeading';
import { ArtistCard } from '../components/ArtistCard';
import { ProductCard } from '../components/shop/ProductCard';
import { Button } from '../components/Button';
import { images } from '../data/images';
import { contact, shopEvents, walkInNotice } from '../data/site';
import { portfolio } from '../data/portfolio';
import { artists } from '../data/artists';
import { products } from '../data/products';
export function Home() {
  return <>
      <section className="relative isolate flex min-h-[620px] items-center overflow-hidden lg:min-h-[680px]" data-id="element-376" data-mp="2dhqkeyd5shjh">
        <img src={images.hero} alt="Tattooed woman overlooking the Las Vegas Strip at night" className="absolute inset-0 -z-10 h-full w-full object-cover object-[70%_center]" data-id="element-377" data-mp="3kvk44fox8t3v" />
        <div className="absolute inset-0 -z-10 bg-ink/60 md:bg-ink/25" data-id="element-378" data-mp="3oyqb5pjuyobe" />
        <div className="mx-auto w-full max-w-[1400px] px-6 pb-16 pt-36 md:px-10" data-id="element-379" data-mp="30w9nt5epkt0r">
          <div className="max-w-2xl" data-id="element-380" data-mp="2vyzzxu6ywpf1">
            <p className="font-script text-xl italic tracking-wide md:text-2xl" data-id="element-381" data-mp="2vvvnyan9gpdt">Meet the best Tattoo Artists in Las Vegas</p>
            <h1 className="mt-3 font-slab text-5xl font-bold uppercase tracking-[0.12em] sm:text-6xl lg:text-7xl" data-id="element-382" data-mp="2mxa5efhshad1">Trip Ink Tattoo</h1>
            <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/90" data-id="element-383" data-mp="2hyp8aoxu36st">
              If you are looking for the best Tattoo Artists on the Las Vegas Strip, then you have come to the right place! Trip Ink Tattoo is one of THE BEST Las
              Vegas Tattoo Shops on the Strip.
            </p>
            <div className="mt-8 flex flex-wrap gap-3" data-id="element-384" data-mp="23alzz8wbjj0u">
              <Button to="/book-now" data-id="element-385" data-mp="1z762698ijcmk">Book Now</Button>
              <Button to="/portfolio" variant="outline" data-id="element-386" data-mp="1z6mlswyigwan">
                See the Skills
              </Button>
            </div>
          </div>
        </div>
      </section>

      <section className="px-6 py-16" aria-label="Walk-in availability" data-id="element-387" data-mp="1kjnur33kg3wg">
        <div className="mx-auto max-w-5xl border border-ink-line px-6 py-8 text-center md:px-14" data-id="element-388" data-mp="1omtzu7exzp1c">
          <p className="font-slab text-sm font-bold uppercase leading-loose tracking-[0.2em] md:text-base" data-id="element-389" data-mp="1an2ronb3x2v9">{walkInNotice}</p>
          <a href={`tel:${contact.phoneMain}`} className="mt-6 inline-flex items-center gap-2 font-slab text-xs font-bold uppercase tracking-[0.2em] underline underline-offset-8 hover:opacity-60" data-id="element-390" data-mp="1fmp3csbaeb1y">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-391" data-mp="28ce6pcbgyn6q" />
            Call the shop
          </a>
        </div>
      </section>

      <section className="py-16" aria-label="Get started" data-id="element-392" data-mp="1yk8i8ckfenwa">
        <QuickLinks data-id="element-393" data-mp="1yinnomy434yf" />
      </section>

      <section className="py-20" aria-labelledby="skills-heading" data-id="element-394" data-mp="2macic9yeo5ij">
        <div className="px-6" data-id="element-395" data-mp="2m7zrt8el0mtv">
          <SectionHeading title="See The Skills" text="Here are the glimpse of exponential work done by the Tattoo Artists" data-id="element-396" data-mp="2r0j7qc0qru1u" />
        </div>
        <div className="mx-auto mt-12 max-w-[1400px] px-1" data-id="element-397" data-mp="fkiwwzzkqqp4">
          <PortfolioGrid items={portfolio.slice(0, 12)} data-id="element-398" data-mp="amzctjg73jp9" />
        </div>
        <div className="mt-10 text-center" data-id="element-399" data-mp="akwm0x77xmjh">
          <Button to="/portfolio" variant="outline" data-id="element-400" data-mp="oedtvkqjlato">
            View the full portfolio
          </Button>
        </div>
      </section>

      <section className="border-y border-ink-line bg-ink-surface py-16" aria-label="Upcoming events" data-id="element-401" data-mp="kdc2fq2va329">
        <div className="mx-auto grid max-w-5xl gap-10 px-6 md:grid-cols-2" data-id="element-402" data-mp="3sslz2inzmg2n">
          {shopEvents.map(event => <div key={event.date} className="flex gap-6" data-id="element-403" data-mp="3nvls85jbd9ah">
              <p className="w-28 shrink-0 font-slab text-2xl font-bold uppercase leading-tight tracking-[0.1em]" data-id="element-404" data-mp="5ofpbelydzus">{event.date}</p>
              <p className="border-l border-ink-line pl-6 leading-relaxed text-ink-muted" data-id="element-405" data-mp="qnsc66gbnjq">{event.text}</p>
            </div>)}
        </div>
      </section>

      <section className="py-20" aria-labelledby="shop-heading" data-id="element-406" data-mp="1c2x07uq17dj4">
        <div className="mx-auto max-w-6xl px-6" data-id="element-407" data-mp="27eepm9kemzhe">
          <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end" data-id="element-408" data-mp="27fpsm761037g">
            <SectionHeading title="Best Tattoo Shops In Las Vegas" align="left" text="Rep the shop. Shirts, sweaters, gift certificates and more." data-id="element-409" data-mp="2cd8341zoyqhk" />
            <Button to="/shop" variant="outline" data-id="element-410" data-mp="2mbozxflb9zbj">
              Visit the shop
            </Button>
          </div>
          <div className="mt-12 grid gap-x-6 gap-y-12 sm:grid-cols-2 lg:grid-cols-4" data-id="element-411" data-mp="2qbpo3ry7povs">
            {products.filter(p => !p.inHouse).slice(0, 4).map(product => <ProductCard key={product.slug} product={product} data-id="element-412" data-mp="303vdqv0zru7t" />)}
          </div>
        </div>
      </section>

      <section className="border-t border-ink-line py-20" aria-labelledby="artists-heading" data-id="element-413" data-mp="353q48xguuhsc">
        <div className="mx-auto max-w-6xl px-6" data-id="element-414" data-mp="3a2kv8moz7cnj">
          <SectionHeading title="Resident Artists" text="Our shop is Artist owned and operated and we work with the most acclaimed, top notch, powerhouse Tattoo Artists. From beginning to end, we strive to give you the best experience possible as you leave wanting more!" data-id="element-415" data-mp="3e1tnto8a54hi" />
          <div className="mt-14 grid gap-x-6 gap-y-12 sm:grid-cols-2 lg:grid-cols-4" data-id="element-416" data-mp="tdidwebpy954">
            {artists.map(artist => <ArtistCard key={artist.slug} artist={artist} data-id="element-417" data-mp="ogrx1os3b9in" />)}
          </div>
        </div>
      </section>
    </>;
}